import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { DarkCard } from './DashboardStyles';
import { commonTooltipStyle } from './ChartUtils';

const GrowthChartCard = ({ data = [] }) => {
    // Using index to avoid collisions with duplicate month labels
    const chartData = data.map((item, index) => ({ ...item, index }));

    return (
        <DarkCard>
            <div className="card-title">Crecimiento de Usuarios</div>
            <ResponsiveContainer width="100%" height={210}>
                <LineChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
                    <XAxis
                        dataKey="index"
                        tick={{ fill: '#9a9a9a', fontSize: 11 }}
                        axisLine={{ stroke: '#3a3a3a' }}
                        tickLine={false}
                        tickFormatter={(idx) => chartData[idx]?.mes || ''}
                    />
                    <YAxis
                        tick={{ fill: '#9a9a9a', fontSize: 11 }}
                        axisLine={false}
                        tickLine={false}
                        label={{ value: 'Usuarios', angle: -90, position: 'insideLeft', fill: '#9a9a9a', fontSize: 11, dy: 40 }}
                    />
                    <Tooltip
                        contentStyle={commonTooltipStyle}
                        labelStyle={{ color: '#BA955E' }}
                        labelFormatter={(idx) => chartData[idx]?.mes || ''}
                    />
                    <Legend
                        wrapperStyle={{ paddingTop: 8, fontSize: 12, color: '#9a9a9a' }}
                        formatter={(value) => <span style={{ color: '#c0c0c0' }}>{value}</span>}
                    />
                    <Line type="monotone" dataKey="Gratis" stroke="#74b567" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="De Pago" stroke="#BA955E" strokeWidth={2} dot={false} />
                </LineChart>
            </ResponsiveContainer>
        </DarkCard>
    );
};

export default GrowthChartCard;
